<template>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
			
			<!-- Header -->
                <HeaderMain />
			<!-- /Header -->
			
			<!--Section Banner-->	
                <Banner />
			<!--/Section Banner-->	
	

			<!--Section Top Schools-->	
                <!-- <TopSchools /> -->
			<!--/Section Top Schools-->	


			<!--Section Benefits-->	
                <!-- <Benefits /> -->
			<!--/Section Benefits-->

			<!--Section Count-->	
                <!-- <Count /> -->
			<!--/Section Count-->		

			<!--Section Top Instructors-->	
                <!-- <TopInstructors /> -->
			<!--/Section Top Instructors-->	

			<!--Section Top Courses-->	
                <!-- <TopCourses /> -->
			<!--/Section Top Courses-->	

			<!--Section Featured School-->	
                <!-- <FeaturedSchool /> -->
			<!--/Section Featured School-->	

			<!--Section Blog-->	
                <!-- <FeaturedBlog /> -->
			<!--/Section Blog-->	

			<!--Section Enrollment-->	
                <!-- <Enrollment /> -->
			<!--/Section Enrollment-->	

			<!--Section Review-->	
                <!-- <Reviews /> -->
			<!--/Section Review-->	

			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
			
		</div>
		<!-- /Main Wrapper -->
</template>

<script>
import HeaderMain from '../Layout/HeaderMain'
import Banner from '../Category/Banner'
import Benefits from '../Category/Benefits'
import TopSchools from '../Category/TopSchools'
import TopCourses from '../Category/TopCourses'
import TopInstructors from '../Category/TopInstructors'
import Count from '../Category/Count'
import FeaturedSchool from '../Category/FeaturedSchool'
import FeaturedBlog from '../Category/FeaturedBlog'
import Enrollment from '../Category/Enrollment'
import Reviews from '../Category/Reviews'
import store from '../../store'

export default {
    components: {
		HeaderMain,
        Banner,
        Benefits,
        TopSchools,
        TopCourses,
        TopInstructors,
        Count,
        FeaturedSchool,
        FeaturedBlog,
        Enrollment,
        Reviews
    },
    props: {
        idcat: String,
    },
    beforeCreate () {
        if (!localStorage.getItem('token')) {
            // this.$router.push({ name: 'login' })
            store.dispatch("checktoken");
        }
    },
    created: function () {
        if(localStorage.getItem('token')){
            store.dispatch("checktoken");
        }
        
        const idcat = this.$route.query.idcat
        localStorage.setItem("idcat", idcat); 
        console.log(idcat);
	},
}

</script>


// WEBPACK FOOTER //
// src/components/Category/index.vue